import { ConnectPopup } from './ConnectPopup';

type WayfairConnectPopupProps = {
  open: boolean;
  closeModal: () => void;
};

export function WayfairConnectPopup({
  open,
  closeModal,
}: WayfairConnectPopupProps) {
  return (
    <ConnectPopup
      open={open}
      title="Connect Wayfair marketplace"
      onClose={() => closeModal()}
    >
      <p className="sk:m-0">
        To integrate Wayfair. Follow{' '}
        <a
          href="https://skupreme.com/knowledge-base/integrating-wayfair-with-skupreme"
          target="_blank"
          rel="noreferrer"
          className="sk:text-link"
        >
          Wayfair Integration Guide
        </a>
        .
      </p>
    </ConnectPopup>
  );
}
